import emailjs from '@emailjs/browser';

document.getElementById('form').addEventListener('submit', async (e) => {
  e.preventDefault();

  const form = e.target;
  const formData = new FormData(form);
  const { name, email, subject, comments } = Object.fromEntries(formData.entries());

  console.log({ name, email, subject, comments }); // Verifica los datos aquí

  try {
    const response = await emailjs.send(
      'service_zy5zofj', // ID del servicio
      'template_h9unv3h', // ID del template
      { from_name: name, from_email: email, subject, message: comments }, // Datos del formulario
      'YTfeNtU-CVQDg1mhD' // Clave pública
    );
    console.log('Email enviado:', response);
  } catch (error) {
    console.error('Error al enviar el email:', error);
  }
});
